import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import AuthFooter from '@/components/layout/AuthFooter/AuthFooter';
import { useConfig } from '@/context/ConfigContext';

const AuthLayout:React.FC = () => {
    const { config } = useConfig();
  
  return <React.Fragment >
    
      <Link href="/home">
      <Image
        src={config?.theme.images.logo?.toString() ?? ""}
        alt="Logo"
        className="w-[90px] h-auto absolute top-8 left-11"
        width={100}
        height={50}
        priority
      />
    </Link>
   
    <div className="flex flex-col h-full justify-center  w-[332px] gap-6 ">
      <span className="block text-5xl  text-[#2c2c2c] ">
        Welcome to
      </span>
      <span className="text-5xl font-bold  text-[#1f1f1f]">
        GTEConnects
      </span>
      <span className="text-[14px] leading-[26px] text-[#767676]">
        Join 25K+ agents using GTEConnects for their hotel booking
        needs. One platform to help you search and book over 2.3M
        properties worldwide.
      </span>
    </div>
    <AuthFooter IsAbsolute />
  </React.Fragment>;
};



export default AuthLayout;
